import type { IconType } from 'react-icons'
import { LuCircleAlert, LuCircleCheck, LuInfo, LuTriangleAlert, LuOctagonAlert } from 'react-icons/lu'
import { accentFor, fonts, mineral } from '../../theme'

/** Constantes del kit de reportes (ver `ReportKit.tsx`). */
export const reportAccent = accentFor('analytics')

export type Tone = 'ok' | 'warn' | 'bad' | 'info' | 'neutral' | 'accent'

export const TONES: Record<Tone, { color: string; deep: string; soft: string; icon: IconType }> = {
  ok: { color: mineral.sabana, deep: mineral.sabanaDeep, soft: mineral.sabanaSoft, icon: LuCircleCheck },
  warn: { color: mineral.oro, deep: mineral.oroDeep, soft: mineral.oroSoft, icon: LuTriangleAlert },
  bad: { color: mineral.aji, deep: '#9c3322', soft: mineral.ajiSoft, icon: LuOctagonAlert },
  info: { color: mineral.lapis, deep: mineral.lapisDeep, soft: mineral.lapisSoft, icon: LuInfo },
  neutral: { color: mineral.pizarra, deep: mineral.ink2, soft: mineral.pizarraSoft, icon: LuCircleAlert },
  accent: { color: reportAccent.color, deep: reportAccent.deep, soft: reportAccent.soft, icon: LuInfo },
}

/** Paleta de series para gráficos: minerales, en orden de contraste. */
export const SERIES = [
  mineral.amatista, mineral.turquesa, mineral.oro, mineral.lapis, mineral.cobre,
  mineral.rodocrosita, mineral.sabana, mineral.ocre, mineral.pizarra,
]

/** Props listos para recharts (ejes, grilla, tooltip). */
export const chart = {
  axis: {
    stroke: mineral.line,
    tickLine: false,
    tick: { fill: mineral.ink3, fontSize: 11, fontFamily: "'Instrument Sans', sans-serif" },
  },
  grid: { stroke: mineral.line, strokeDasharray: '3 4', vertical: false },
  tooltip: {
    contentStyle: {
      background: '#fff', border: `1px solid ${mineral.line}`, borderRadius: 12,
      boxShadow: '0 12px 30px -16px rgba(74, 52, 30, 0.35)', fontSize: 12, padding: '8px 12px',
    },
    labelStyle: { color: mineral.ink, fontWeight: 600, marginBottom: 4 },
    itemStyle: { color: mineral.ink2 },
    cursor: { fill: `${reportAccent.color}0f` },
  },
  legend: { wrapperStyle: { fontSize: 12, color: mineral.ink2 } },
}

/** Estilo para <select> nativos dentro de FilterField. */
export const selectStyle: React.CSSProperties = {
  width: '100%', height: 40, padding: '0 12px', borderRadius: 10, border: `1px solid ${mineral.lineStrong}`,
  background: '#fff', color: mineral.ink, fontSize: 13.5, outline: 'none',
}

/** Estilos comunes para tablas de reporte (usar con <table> nativa o Chakra Table). */
export const table = {
  th: {
    padding: '10px 14px', fontSize: 10.5, fontWeight: 600, fontFamily: fonts.mono, letterSpacing: '0.08em',
    textTransform: 'uppercase' as const, color: mineral.ink3, background: mineral.surfaceAlt,
    borderBottom: `1px solid ${mineral.line}`, textAlign: 'left' as const, whiteSpace: 'nowrap' as const,
  },
  td: { padding: '11px 14px', fontSize: 13, color: mineral.ink2, borderBottom: `1px solid ${mineral.line}`, verticalAlign: 'middle' as const },
}
